export class DialogModelSalesDashboard {
    constructor(
      public data: any
    ) {}
  }
  